import Paginacao from '@/core/store/default/paginacaoListagem'

export default {
	paginacao: Paginacao(['dataCriacao'], 25, 'DESC'),
	filtro: {
		conteudo: {
			default: null,
			label: 'Pesquisa',
			value: null,
		},
	},
}
